import React from 'react';
import { useTranslation } from 'react-i18next';
import './ThankYou.scss';

const ThankYou = () => {
    const { t } = useTranslation();

    return (<div className='thank-you'>
        <div className='title'>{t('Thank You')}</div>
        <div className='sun-title'>{t('Your order has been successfully received')}!</div>
    </div>);
};

export default ThankYou;
